import { call, put, takeEvery } from 'redux-saga/effects';
// Constants
import { SUBSCRIPTION } from '../../Actions/Subscription/types';
import {
  getSubscriptionSuccess,
  getSubscriptionFailure,
  getSubscriptionInfoSuccess,
  forbiddenAccessAction,
  noActiveSubsAction,
} from '../../Actions/Subscription/subscriptionAction';
import {
  getSubscriptionDetails,
  getSubscriptionInfoApi,
} from '../../Services/Subscription/subscriptionApi';
import moment from 'moment';
import {
  loadingAction,
  stopLoadingAction,
} from 'src/Actions/Generic/genericActions';
import { filterActiveStatus } from 'src/Utils';
import i18n from 'src/i18n';

// Saga handlers
export default function* subscriptionSaga() {
  yield takeEvery(SUBSCRIPTION.GET_SUBSCRIPTION, fetchSubscriptionDetails);
  yield takeEvery(
    SUBSCRIPTION.GET_SUBSCRIPTION_INFO,
    handleGetSubscriptionInfo
  );
}

export function* fetchSubscriptionDetails() {
  try {
    let response = yield call(getSubscriptionDetails);

    if (response && response.status === 200 && response.data) {
      let a = updateSusbcriptions(response.data);

      yield put(getSubscriptionSuccess(a.formattedRes, a.count));
    }
  } catch (e) {
    yield put(getSubscriptionFailure(e));
  }
}

function getDaystext(diff){
  if(diff === 1) return `${diff} ${i18n.t('daySingular')}`;
  else return `${diff} ${i18n.t('dayPlural')}`;
}

function getCoursestext(i){
  if(i.courseUsage.available === 1) return `${i.courseUsage.available} ${i18n.t('courseUsageSingular')}`;
  else return `${i.courseUsage.available} ${i18n.t('courseUsagePlural')}`;
}

function getEducationSubscription(j, i, diff, diffhours){
  let status = '';
  let errorMessage = '';
  let text = null;
  let count = 0;
  /* eslint-disable no-return-assign, no-param-reassign */
  if (diff > 0 && diff <= 15 && i.courseUsage.available <= 10) { 
    let daysText = getDaystext(diff);
    let coursesText = getCoursestext(i);

    status = 'About To Expire';
    errorMessage = i18n.t('subAboutToExpireMsg1', { daysText: daysText, coursesText: coursesText, date: moment(j.endDate).format('MMMM D, YYYY') });
    count = count + 1;
  } else if (diff === 0 && i.courseUsage.available <= 10) {
    if (diffhours >= 0) {
      let coursesText = getCoursestext(i);

      status = 'About To Expire';
      errorMessage = i18n.t('subAboutToExpireMsg2', { coursesText: coursesText });
      count = count + 1;
    } else {
      status = 'Expired';
      errorMessage = i18n.t('subExpiredMsg');
      count = count + 1;
      text = 'expired';
    }
  } else if (diff < 0) {
    status = 'Expired';
    errorMessage = i18n.t('subExpiredMsg');
    count = count + 1;
    text = 'expired';
  } else if (diff > 0 && diff <= 15) {
    let daysText = getDaystext(diff);

    count = count + 1;
    status = 'About To Expire';
    errorMessage = i18n.t('subAboutToExpireMsg3', { daysText: daysText, date: moment(j.endDate).format('MMMM D, YYYY') });
  } else if (diff === 0) {
    if (diffhours >= 0) {
      status = 'About To Expire';
      errorMessage = i18n.t('subAboutToExpireMsg4');
      count = count + 1;
    } else {
      status = 'Expired';
      errorMessage = i18n.t('subExpiredMsg');
      count = count + 1;
      text = 'expired';
    }
  } else if (i.courseUsage.available <= 10) {
    let coursesText = getCoursestext(i);
    count = count + 1;
    status = 'About To Expire';
    errorMessage = i18n.t('subAboutToExpireMsg5', { coursesText: coursesText, date: moment(j.endDate).format('MMMM D, YYYY') });
  }
  return {
    updatedStatus: status,
    updatedErrorMessage: errorMessage,
    updatedText: text,
    updatedCount: count
  }
  /* eslint-enable no-return-assign, no-param-reassign */
}

function getNonAdhocSubscription(j, i, diff, diffhours){
  let status = '';
  let errorMessage = '';
  let text = null;
  let count = 0;
  if (diff < 0) {
    count = count + 1;
    status = 'Expired';
    text = 'expired';
    errorMessage = i18n.t('subExpiredMsg');
  } else if (diff === 0) {
    if (diffhours >= 0) {
      status = 'About To Expire';
      errorMessage = i18n.t('subAboutToExpireMsg4');
      count = count + 1;
    } else {
      status = 'Expired';
      errorMessage = i18n.t('subExpiredMsg');
      count = count + 1;
      text = 'expired';
    }
  } else if (diff > 0 && diff <= 15) {
    let daysText = getDaystext(diff);
    count = count + 1;
    status = 'About To Expire';
    errorMessage = i18n.t('subAboutToExpireMsg3', { daysText: daysText, date: moment(j.endDate).format('MMMM D, YYYY') });
  }
  return {
    updatedStatus: status,
    updatedErrorMessage: errorMessage,
    updatedText: text,
    updatedCount: count
  }
}

function getSubscriptionInformation(j, i, subs){
  let count = 0;
  let newSubs = subs.map((j) => {
    const diff = Math.floor(j.minutesRemaining / (60 * 24));
    const diffhours = Math.floor(j.minutesRemaining / 60);

    let status = '';
    let errorMessage = '';
    let text = null;
    if (
      j.packageName === 'EDUCATION' &&
      i.courseUsage.type === 'LIMITED'
    ) {
      const {updatedStatus, updatedErrorMessage, updatedText, updatedCount} = getEducationSubscription(j, i, diff, diffhours);
      status = updatedStatus;
      errorMessage = updatedErrorMessage;
      text = updatedText;
      count = updatedCount
    } else if (j.packageName !== 'ADHOC') {
      const {updatedStatus, updatedErrorMessage, updatedText, updatedCount} = getNonAdhocSubscription(j, i, diff, diffhours);
      status = updatedStatus;
      errorMessage = updatedErrorMessage;
      text = updatedText;
      count = updatedCount
    }
    return {
      ...j,
      status,
      errorMessage,
      text
    };
  });
  return {newSubs, updatedCount: count};
}

function checkSubLength(j, i, subs){
  if (subs?.length > 0) {
    return getSubscriptionInformation(j, i, subs);
  }
}

function getModValue(modValue){
  if (modValue && modValue.length > 0) {
    return (modValue
      .filter((x) => x.modality !== null)
      .map((k) => {
        let subValue =
          k.subModality && k.subModality.length > 0
            ? k.subModality.join(', ')
            : '';
        return subValue ? `${subValue}` : `${k.modality}`;
      })
    )
  }
}

function updateSusbcriptions(res) {
  let formattedRes = [];
  let formattedMod = [];
  let count = 0;
  if (res?.length > 0) {
    formattedRes = res.map((i) => {
      let subs = i.onyxSubscriptionDetails;
      let modValue = i.modalitySubModality;     
      let { newSubs, updatedCount } = checkSubLength(j, i, subs);
      count = updatedCount;
      formattedMod = getModValue(modValue);
      return {
        ...i,
        onyxSubscriptionDetails: newSubs,
        formattedMod,
      };
    });
  }
  return { formattedRes, count };
}

export function* handleGetSubscriptionInfo() {
  try {
    // Start loading
    yield put(loadingAction());
    const response = yield call(getSubscriptionInfoApi);
    if (response?.status === 200 && response?.data) {
      let {formattedActiveCollabList, formattedActiveAdhocList } = yield call(filterActiveStatus, response.data.userSubscriptionInfo);
      let isCollaborationActive;
      if (formattedActiveCollabList?.length > 0) isCollaborationActive = true;
      else isCollaborationActive = false;
      let isAdhocActive;
      if (formattedActiveAdhocList?.length > 0) isAdhocActive = true;
      else isAdhocActive = false;
      if (!(isCollaborationActive || isAdhocActive)) 
        yield put(noActiveSubsAction());
      
      yield put(getSubscriptionInfoSuccess(response.data));
    }
    // Stop loading task complete
    yield put(stopLoadingAction());
  } catch (e) {
    // Stop loading if error
    if (e.status === 403) 
      yield put(forbiddenAccessAction());
    
    yield put(stopLoadingAction());
  }
}
